import React from "react";
import InstrumentServiceTable from "../../serviceCase/serviceCaseForm/InstrumentServiceTable";
import {Card} from "react-bootstrap";
import InstrumentLoanSelector from "./InstrumentLoanSelector";

function InstrumentLoanSection(props) {
    return (
        <div className="mb-3">
            <label className="form-label">Prístroje</label>
            {props.data.Pristroje.map((item, ndx) => (
                <div className="mb-3">
                    <Card border={"muted"} bg={"light"}>
                        <div className="m-lg-3">
                            <InstrumentServiceTable empty={false} unpackSection={true}
                                                    selectInstrument={props.selectInstrument}
                                                    instrument={item} instrumentIndex={ndx}
                                                    data={props.data}
                                                    deleteInstrument={props.deleteInstrument}
                                                    unpackable={false}
                            />
                        </div>
                    </Card>
                </div>
            ))}
            <InstrumentLoanSelector value=""
                                    selectInstrument={props.selectInstrument}
                                    optionDisplay="SNR"
                                    ndx={props.ndx}
                                    index={null}
                                    stateResetOnChange={true}
                                    data={props.data}
                                    empty={true}
            />
        </div>
    )
}

export default InstrumentLoanSection
